import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.scss";
import "./styles/common-style.scss";
import { i18nReady } from "./i18n";
import { LanguageContextProvider } from "./components/language/languageContext.tsx";
import { UserDetailProvider } from "./hooks/userDetailsContext.tsx";
import PopupProvider from "./utils/comingSoon.tsx";
import { ToastContainer } from "react-toastify";
import Loader from "./components/Loader/Loader.tsx";
import "./styles/HomePage.scss";
import "./styles/new_design.scss";
 
const I18nGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    i18nReady.then(() => setReady(true));
  }, []);
  if (!ready) return <Loader />;
  return <>{children}</>;
};

const rootDomain = window.location.hostname;

let pageTitle = "Clinical Visuals"; // default

if (rootDomain.includes("liger")) {
  pageTitle = "Liger Visuals";
} else if (rootDomain.includes("kr")) {
  pageTitle = "KR Hospitals";
} else if (rootDomain.includes("clncl.video")) {
  pageTitle = "Share Animations";
} else {
  pageTitle = "Clinical Visuals";
}

document.title = pageTitle;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LanguageContextProvider>
      <UserDetailProvider>
        <PopupProvider>
          <ToastContainer />
          <I18nGate>
            <App />
          </I18nGate>
        </PopupProvider>
      </UserDetailProvider>
    </LanguageContextProvider>
  </React.StrictMode>
);
